import { render } from "./edit.vue?vue&type=template&id=0685d68e"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/stay/receiver/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0685d68e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0685d68e', __exports__)) {
    console.log('reload')
    api.reload('0685d68e', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=0685d68e", () => {
    console.log('re-render')
    api.rerender('0685d68e', render)
  })

}


export default __exports__